<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col-6">
          <div class="row">
            <h3
              class="ml-md-3 ml-1 mb-md-0"
              :class="type === 'dark' ? 'text-white' : ''"
            >
              {{ title }}
            </h3>
            <select
              v-model="selectedMode"
              @change="search(keyword)"
              class="ml-sm-2"
            >
              <option value="0">ทั้งหมด</option>
              <option value="1">จ่ายแล้ว</option>
              <option value="2">ผ่อน</option>
            </select>
            <select
              v-model="selectedType"
              @change="search(keyword)"
              class="ml-sm-2"
            >
              <option value="0">ทั้งหมด</option>
              <option value="2">เฉพาะ ใบเสร็จคำนวนภาษี</option>
            </select>
          </div>
        </div>
        <div class="col text-right">
          <base-button type="primary" size="sm" @click="showModal = true">
            เพิ่มใบเสร็จใหม่</base-button
          >
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="receipts"
      >
        <template slot="columns">
          <th>วันที่</th>
          <th>ชื่อสกุล</th>
          <th>เบอร์โทร</th>
          <th>ประเภทงานที่ทำ</th>
          <th>บริษัทประกัน</th>
          <th>ยี่ห้อ</th>
          <th>ทะเบียน</th>
          <th>ยอดรวม</th>
          <th>ไฟล์</th>
          <th></th>
        </template>

        <template slot-scope="{ row }">
          <th
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            {{ formatDate(row.created_at) }}
          </th>
          <th
            scope="td-bold"
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            <div class="media align-items-center">
              <div class="media-body cutname">
                <span
                  class="name mb-0 text-sm"
                  @click="view(row.type, row.id, row.receipt)"
                  >{{ row.name }}
                  <span v-if="row.type == 1">(กลุ่ม)</span></span
                >
              </div>
            </div>
          </th>
          <td
            class="td-normal"
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            {{ row.tel }}
          </td>
          <td
            class="td-normal"
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            <span v-if="row.insurance_price"
              >{{ row.insurance_type_name }}
            </span>
            <span v-if="row.wsu_price && row.insurance_price"> + </span>
            <span v-if="row.wsu_price">พรบ</span>
            <span v-if="row.wsu_price && row.tax_price"> + </span>
            <span v-if="row.tax_price && row.insurance_price && !row.wsu_price">
              +
            </span>
            <span v-if="row.tax_price">ภาษี</span>
          </td>
          <td
            class="td-normal"
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            <span v-if="row.insurance_company_name !== 'OTHER'">
              {{ row.insurance_price ? row.insurance_company_name : "" }}
            </span>
            <span v-else>
              {{ row.if_other_insurance_company }}
            </span>
          </td>
          <td
            class="td-normal"
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            {{ row.car_type === "car" ? row.brand_name : "มอเตอร์ไซต์" }}
          </td>
          <td
            class="td-normal"
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            {{ row.license_plate }}
          </td>
          <td
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            <!-- {{
              (
                (row.wsu_price ? parseInt(row.wsu_price) : 0) +
                (row.insurance_price ? parseInt(row.insurance_price) : 0) +
                (row.tax_price ? parseInt(row.tax_price) : 0) +
                (row.other_price ? parseInt(row.other_price) : 0) +
                (row.is_inspected && row.car_type === "car" ? 200 : 60)
              ).toLocaleString()
            }} -->
            <span v-if="row.cal_receipt_type !== 2">{{
              (
                (row.wsu_price ? parseInt(row.wsu_price) : 0) +
                (row.insurance_price ? parseInt(row.insurance_price) : 0) +
                (row.tax_price ? parseInt(row.tax_price) : 0) +
                (row.other_price ? parseInt(row.other_price) : 0) +
                (row.inspect_price_car ? parseInt(row.inspect_price_car) : 0) +
                (row.inspect_price_motorcycle
                  ? parseInt(row.inspect_price_motorcycle)
                  : 0)
              ).toLocaleString()
            }}</span>
            <span v-if="row.cal_receipt_type !== 2">(</span
            >{{ row.real_price ? Number(row.real_price).toLocaleString() : ""
            }}<span v-if="row.cal_receipt_type !== 2">)</span>
          </td>
          <td
            class="td-normal"
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            <span v-if="!row.is_cancelled && row.cal_receipt_type !== 2">
              <a href="#" @click="getPDF(row.id, row.type, row.receipt)">
                <img
                  src="/img/brand/ic_pdf.png"
                  width="24"
                  height="24"
                  alt="ใบเสร็จ"
                />
                <!-- RCP{{ row.receipt }}.pdf -->
              </a></span
            >
            <span v-else>
              <a :href="'/quotation/' + row.id">
                <img
                  src="/img/brand/ic_pdf.png"
                  width="24"
                  height="24"
                  alt="ใบเสร็จ"
                />
                <!-- RCP{{ row.receipt }}.pdf -->
              </a></span
            >
            <span v-if="!row.is_cancelled"> </span>
            <!-- <span v-else>{{ row.note }} </span> -->
          </td>
          <td
            :class="row.is_installment && !row.paid_3 ? 'bg-installment' : ''"
          >
            <span v-if="!row.is_cancelled" :class="lvl != 999 ? 'none' : ''"
              ><base-button
                type="warning"
                size="sm"
                @click="
                  goTo(row.type, row.id, row.receipt, row.cal_receipt_type)
                "
                >แก้ไข</base-button
              >
              <base-button
                type="danger"
                size="sm"
                @click="
                  (showCancelModal = true),
                    row.type === 1
                      ? (selectedReceiptGroup = row.receipt)
                      : (selectedReceipt = row.id)
                "
                >ยกเลิก</base-button
              ></span
            >
            <span class="cancelled" v-else>{{ row.note }} </span>
            <!-- <span class="cancelled" v-else>ยกเลิกแล้ว</span> -->
          </td>
        </template>
      </base-table>
    </div>

    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    ></div>
    <Modal :show="showModal">
      <div class="col text-center">
        <h2>เลือกประเภทบิลที่ต้องการ</h2>
        <button
          type="button"
          class="close mt--5"
          data-dismiss="modal"
          aria-label="Close"
          @click="showModal = false"
        >
          <span>×</span>
        </button>
        <div class="row justify-content-around mt-4">
          <router-link to="receiptAddNew">
            <base-button type="info" size="md"
              >บิลเดี่ยว</base-button
            ></router-link
          >
          <router-link to="receiptAddNewGroup">
            <base-button type="warning" size="md">บิลกลุ่ม</base-button>
          </router-link>
        </div>
      </div></Modal
    >
    <Modal :show="showCancelModal">
      <div class="col text-center">
        <h2>ใส่เหตุผลที่ต้องการยกเลิกใบเสร็จ</h2>
        <button
          type="button"
          class="close mt--5"
          data-dismiss="modal"
          aria-label="Close"
          @click="showCancelModal = false"
        >
          <span>×</span>
        </button>
        <div class="col-12 mt-3">
          <base-input
            alternative=""
            placeholder="เหตุผล"
            type="text"
            input-classes="form-control-alternative"
            v-model="cancelled.note"
          />
        </div>
        <div class="row justify-content-around mt-4">
          <base-button type="primary" size="md" @click="cancel()"
            >ยืนยัน</base-button
          >
          <base-button type="warning" size="md" @click="showCancelModal = false"
            >ยกเลิก</base-button
          >
        </div>
      </div></Modal
    >
  </div>
</template>
<script>
import Modal from "../../components/Modal";
import axios from "axios";
import kickMixin from "../../mixins/kickMixin";
import moment from "moment";

moment.locale("th");

export default {
  name: "receipt-table",
  mixins: [kickMixin],
  components: {
    Modal,
  },
  props: {
    type: {
      type: String,
    },
    title: String,
    receipts: {
      type: Array,
      default: function() {
        return [];
      },
    },
    total: {
      type: Number,
    },
    page: {
      type: Number,
    },
  },
  computed: {
    calculateTotal() {
      return this.receipts.length;
    },
  },
  methods: {
    view(type, key, receipt) {
      if (type == 0) {
        let routeData = this.$router.resolve({ path: "/receiptView/" + key });
        window.open(routeData.href, "_blank");
      } else {
        let routeData = this.$router.resolve({
          path: "/receiptGroupView/" + receipt,
        });
        window.open(routeData.href, "_blank");
      }
    },
    formatDate(date) {
      let monthNames = [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค.",
      ];

      let day = moment(date).date();
      let month = monthNames[moment(date).month()];
      let year = moment(date).year() + 543;

      // let parsedDate = Date.parse(date);
      // let newDate = new Date(parsedDate);
      // let day = newDate.getDate();
      // let month = newDate.getMonth();
      // let year = newDate.getYear();

      // let hour = newDate.getHours();
      // let min = newDate.getMinutes();
      // let sec = newDate.getSeconds();
      // return (
      //   day +
      //   " " +
      //   monthNames[month] +
      //   " " +
      //   (year + 543 + 1900) +
      //   " " +
      //   hour +
      //   ":" +
      //   min +
      //   ":" +
      //   sec
      // );
      return day + " " + month + " " + year;
    },
    loadAllReceipts: function() {
      var localApp = this;
      axios
        .get(
          "https://api.sd5525.com/api/receipt?mode=" +
            localApp.selectedMode +
            "&type=" +
            localApp.selectedType +
            "&page=" +
            localApp.page,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          localApp.$emit("update:receipts", response.data.data.data);
          localApp.$emit("update:total", response.data.data.total);
        })
        .catch(function() {
          // localApp.kick();
        });
    },
    search: async function(keyword) {
      let localApp = this;
      localApp.keyword = keyword;
      await axios
        .get(
          "https://api.sd5525.com/api/receipt/search/q?keyword=" +
            localApp.keyword +
            "&mode=" +
            localApp.selectedMode +
            "&type=" +
            localApp.selectedType +
            "&page=" +
            localApp.page,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          localApp.$emit("update:receipts", response.data.data.data);
          localApp.$emit("update:total", response.data.data.total);
        })
        .catch(function(error) {
          alert(error);
        });
    },
    goTo(type, key, receipt, receipt_type) {
      if (localStorage.level == 999) {
        if (receipt_type === 2) this.$router.push("/calculator/" + key);
        else {
          if (type == 0) {
            let routeData = this.$router.resolve({ path: "/receipt/" + key });
            window.open(routeData.href, "_blank");
          } else {
            let routeData = this.$router.resolve({
              path: "/receiptGroup/" + receipt,
            });
            window.open(routeData.href, "_blank");
          }
        }
      }
    },
    cancel() {
      var localApp = this;
      let finalUrl =
        localApp.selectedReceipt !== ""
          ? "https://api.sd5525.com/api/receipt/cancel/" +
            localApp.selectedReceipt
          : "https://api.sd5525.com/api/receiptGroup/cancel/" +
            localApp.selectedReceiptGroup;
      axios
        .patch(finalUrl, localApp.cancelled, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            window.location.reload();
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
    getPDF(id, type, receipt) {
      if (type === 0) {
        window.open("https://api.sd5525.com/api/receipt/getPDF/" + id, "_blank");
        // axios
        //   .get("https://api.sd5525.com/api/receipt/getPDF/" + id, {
        //     headers: {
        //       Authorization: "Bearer " + localStorage.token,
        //     },
        //     responseType: "blob",
        //   })
        //   .then(function(response) {
        //     const url = window.URL.createObjectURL(new Blob([response.data]));
        //     const link = document.createElement("a");
        //     link.href = url;
        //     link.setAttribute("download", "RCP" + receipt + ".pdf");
        //     document.body.appendChild(link);
        //     link.click();
        //   })
        //   .catch(function(error) {
        //     alert(error);
        //   });
      } else {
        window.open(
          "https://api.sd5525.com/api/receipt/getPDFgroup/" + receipt,
          "_blank"
        );
        // axios
        //   .get("https://api.sd5525.com/api/receipt/getPDFgroup/" + receipt, {
        //     headers: {
        //       Authorization: "Bearer " + localStorage.token,
        //     },
        //     responseType: "blob",
        //   })
        //   .then(function(response) {
        //     const url = window.URL.createObjectURL(new Blob([response.data]));
        //     const link = document.createElement("a");
        //     link.href = url;
        //     link.setAttribute("download", "RCP" + receipt + ".pdf");
        //     document.body.appendChild(link);
        //     link.click();
        //   })
        //   .catch(function(error) {
        //     alert(error);
        //   });
      }
    },
  },
  data() {
    return {
      keyword: "",
      selectedMode: "0",
      selectedType: "0",
      showCancelModal: false,
      showModal: false,
      lvl: 0,
      cancelled: {
        note: "",
      },
      selectedReceipt: "",
      selectedReceiptGroup: "",
    };
  },
  watch: {
    page: function() {
      if (this.keyword === "") {
        this.loadAllReceipts();
      } else {
        this.search(this.keyword);
      }
    },
  },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      this.lvl = localStorage.level;
      this.loadAllReceipts();
    }
  },
};
</script>
<style scoped>
.cancelled {
  color: red;
}
.pointer {
  cursor: pointer;
}
.none {
  display: none !important;
}
.table td,
.btn-sm,
.text-sm {
  font-size: 1rem !important;
}
.table thead th,
.table th {
  font-size: 0.9rem !important;
}

.h3,
h3 {
  font-size: 1.2rem !important;
}
.cutname {
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.bg-installment {
  background-color: #f6eec4;
}
</style>
